<template>
    <div class="scorm-container">
        <h3>{{component.name}} </h3>

        <h5 v-if="getStatus() == 'Not Started'">Status: Not Started</h5>
        <h5 v-if="getStatus() == 'Started'" class="text-primary">Status: Started</h5>
        <h5 v-if="getStatus() == 'Completed'" class="text-success">Status: Completed</h5>
        <h5 v-if="getStatus().startsWith('Failed')" class="text-danger">Status: {{getStatus()}}</h5>
        <h5 v-if="getStatus().startsWith('Passed')" class="text-success">Status: {{getStatus()}}</h5>

        <button v-on:click="launchScormFile">Launch</button>
    </div>
</template>

<style scoped>
    .scorm-container {
        border: 1px dotted black;
        text-align: center;
        padding: 10px;
    }
</style>
<script>

    var newWin = null;

    export default {
        name: 'ScormViewer',
        props: {
            component: Object,
            course: Object,
            courseDetails: Object
        },
        data: function () {
            return {
                frameSrc: null
            }
        },
        methods: {
            launchScormFile: function () {
                console.log("launchScormFile");
                var src = this.$store.state.apiBaseUrl;
                if (window.location.host.toLowerCase().indexOf("localhost") > -1) {
                    src = "https://localhost:44317/Api";
                }

                src = `${src}/Scorm/${this.$store.state.user.id}/${this.course.id}/${this.component.fileName}`;

                newWin = window.open(src);
                var t = this;

                t.$emit('windowOpened');
                var interval = window.setInterval(function () {
                    try {
                        console.log("Window still open");
                        if (newWin == null || newWin.closed) {
                            window.clearInterval(interval);
                            t.$emit('windowClosed');
                        }
                    }
                    catch (e) {
                    }
                }, 1000);
            },
            getStatus() {
                console.log("getStatus");
                for (var c = 0; c < this.courseDetails.chapters.length; c++) {
                    var chapter = this.courseDetails.chapters[c];
                    for (var p = 0; p < chapter.pages.length; p++) {
                        var page = chapter.pages[p];
                        for (var o = 0; o < page.components.length; o++) {
                            var component = page.components[o];
                            if (component == this.component) {
                                if (page.userCompleted) {

                                    if (page.percentageWeight) {
                                        if (page.userPassed) {
                                            return "Passed: " + page.userScore + "%";
                                        }
                                        else {
                                            return "Failed: " + page.userScore + "%";
                                        }
                                    } 

                                    return "Completed";
                                }
                            }
                        }
                    }
                }

                if (this.component.started) {
                    return "Started";
                }


                return "Not Started";

            }
        },
        async mounted() {


            this.frameSrc = "";
        }
    }
</script>